import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
import AutocompleteDropdown from 'flarum/common/components/AutocompleteDropdown';
import extractText from 'flarum/common/utils/extractText';
import getCountries from '../util/getCountries';
import getFlagEmojiUrl from '../util/getFlagEmojiUrl';
const MAX_RESULTS = 50;

/**
 * A searchable country picker. The user types to filter the list of countries
 * (by localized name or code) and selects one; the chosen flag is rendered
 * inline. Clearing the input clears the selection.
 */
export default class CountryFlagPicker extends AutocompleteDropdown {
  constructor() {
    super(...arguments);
    /** Free-text query the user has typed into the input. */
    _defineProperty(this, "query", '');
    /** Whether the user has edited the input since the value was last applied. */
    _defineProperty(this, "dirty", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.syncQueryToValue();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    // Reflect external value changes (e.g. after a save) back into the input,
    // unless the user is actively editing it.
    if (!this.dirty && !this.hasFocus) {
      this.syncQueryToValue();
    }
  }
  syncQueryToValue() {
    const current = this.currentCountry();
    this.query = current ? current.name : '';
  }
  currentCountry() {
    const code = (this.attrs.value || '').toUpperCase();
    if (!code) return undefined;
    return getCountries().find(c => c.code === code);
  }
  view(vnode) {
    const code = this.attrs.value || '';
    const flagUrl = code ? getFlagEmojiUrl(code) : null;
    const placeholder = extractText(app.translator.trans('fof-geoip.lib.custom_flag.placeholder'));
    vnode.children = [m("div", {
      className: "CountryFlagPicker-control"
    }, flagUrl && m("img", {
      className: "CountryFlagPicker-flag",
      src: flagUrl,
      alt: "",
      height: "16"
    }), m("input", {
      className: "FormControl",
      autocomplete: "off",
      placeholder: placeholder,
      disabled: this.attrs.disabled,
      value: this.query,
      oninput: e => {
        this.query = e.target.value;
        this.dirty = true;
        // Clearing the field clears the selection.
        if (this.query.trim() === '' && this.attrs.value) {
          this.attrs.onchange(null);
        }
      }
    }))];
    return super.view(vnode);
  }
  suggestions() {
    if (!this.dirty) return [];
    const q = this.query.trim().toLowerCase();
    if (q === '') return [];
    const matches = getCountries().filter(c => c.name.toLowerCase().includes(q) || c.code.toLowerCase() === q).slice(0, MAX_RESULTS);
    return matches.map(country => {
      const flagUrl = getFlagEmojiUrl(country.code);
      return m("li", {
        "data-index": country.code
      }, m("button", {
        type: "button",
        className: "CountryFlagPicker-option",
        onclick: () => this.select(country)
      }, flagUrl && m("img", {
        className: "CountryFlagPicker-optionFlag",
        src: flagUrl,
        alt: "",
        height: "16"
      }), m("span", {
        className: "CountryFlagPicker-optionName"
      }, country.name)));
    });
  }
  select(country) {
    this.query = country.name;
    this.dirty = false;
    this.hasFocus = false;
    this.inputElement().blur();
    this.attrs.onchange(country.code);
  }
}
flarum.reg.add('fof-geoip', 'common/components/CountryFlagPicker', CountryFlagPicker);